import { HttpContext } from '@angular/common/http';
import { SKIP_ERROR_MODAL } from './skip-error-modal.token';

export interface HttpOpts {
  skipErrorModal?: boolean;
}

export function buildHttpContext(opts?: HttpOpts): HttpContext {
  const ctx = new HttpContext();
  if (opts?.skipErrorModal) {
    ctx.set(SKIP_ERROR_MODAL, true);
  }
  return ctx;
}
